import { call, put, take, takeEvery } from "redux-saga/effects";

import { PaginateQuery, ResponseGenerator } from "../../interfaces";
import {
  ADD_SKILL,
  AddSkillAction,
  DELETE_SKILL,
  DeleteSkillAction,
  GET_SKILL,
  GetSkillAction,
  GetSkillsAction,
  UPDATE_SKILL,
  UpdateSkillAction,
  GET_SKILLS,
  UploadSkillVideoAction,
  UPLOAD_SKILL_VIDEO,
  GET_SKILLS_BY_LESSON,
  GetSkillsByLessonAction,
  GET_SKILLS_SUGGESTION,
  GetSkillsSuggestionAction,
  GET_SKILLS_BY_SUBJECT,
  GetSkillsBySubjectAction,
  ToggleSkillStateAction,
  TOGGLE_SKILL_STATE,
  CopySkillsAction,
  COPY_SKILLS,
} from "./actionTypes";
import {
  addSkillError,
  addSkillSuccess,
  copySkillsError,
  copySkillsSuccess,
  deleteSkillError,
  deleteSkillSuccess,
  getSkillError,
  getSkillSuccess,
  getSkillsByLessonError,
  getSkillsByLessonSuccess,
  getSkillsBySubjectError,
  getSkillsBySubjectSuccess,
  getSkillsError,
  getSkillsSuccess,
  getSkillsSuggestionSuccess,
  getSkillsSuggestionsError,
  toggleSkillStateError,
  toggleSkillStateSuccess,
  updateSkillError,
  updateSkillSuccess,
  uploadSkillVideoError,
  uploadSkillVideoSuccess,
} from "./actions";
import {
  addSkill,
  copySkills,
  deleteSkill,
  getSkill,
  getSkills,
  getSkillsByLesson,
  getSkillsBySubject,
  getSkillsSuggestion,
  toggleSkillState,
  updateSkill,
  uploadSkillVideo,
} from "../../helpers/backend_helper";

function* getSkillsSaga({ payload: { request, history } }: GetSkillsAction) {
  try {
    const response: ResponseGenerator = yield call(
      getSkills,
      request as PaginateQuery
    );
    yield put(getSkillsSuccess(response.data));
  } catch (error) {
    yield put(getSkillsError(error));
  }
}

function* getSkillsByLessonSaga({
  payload: { lessonId, history },
}: GetSkillsByLessonAction) {
  try {
    const response: ResponseGenerator = yield call(getSkillsByLesson, lessonId);
    yield put(getSkillsByLessonSuccess(response.data));
  } catch (error) {
    yield put(getSkillsByLessonError(error));
  }
}

function* getSkillsBySubjectSaga({
  payload: { subjectId, history },
}: GetSkillsBySubjectAction) {
  try {
    const response: ResponseGenerator = yield call(
      getSkillsBySubject,
      subjectId
    );
    yield put(getSkillsBySubjectSuccess(response.data));
  } catch (error) {
    yield put(getSkillsBySubjectError(error));
  }
}

function* getSkillSaga({ payload: { id, history } }: GetSkillAction) {
  try {
    const response: ResponseGenerator = yield call(getSkill, id);
    yield put(getSkillSuccess(response.data));
  } catch (error) {
    yield put(getSkillError(error));
  }
}

function* addSkillSaga({ payload: { request, history } }: AddSkillAction) {
  try {
    const response: ResponseGenerator = yield call(addSkill, request);
    yield put(addSkillSuccess(response.data));
  } catch (error) {
    yield put(addSkillError(error));
  }
}

function* updateSkillSaga({
  payload: { id, request, history },
}: UpdateSkillAction) {
  try {
    const response: ResponseGenerator = yield call(updateSkill, id, request);
    yield put(updateSkillSuccess(response.data));
  } catch (error) {
    yield put(updateSkillError(error));
  }
}

function* deleteSkillSaga({ payload: { id, history } }: DeleteSkillAction) {
  try {
    yield call(deleteSkill, id);
    yield put(deleteSkillSuccess(id));
  } catch (error) {
    yield put(deleteSkillError(error));
  }
}

function* uploadSkillVideoSaga({
  payload: { file, history, skillId },
}: UploadSkillVideoAction) {
  try {
    const response: ResponseGenerator = yield call(
      uploadSkillVideo,
      file,
      skillId
    );
    yield put(uploadSkillVideoSuccess(response.data));
  } catch (error) {
    yield put(uploadSkillVideoError(error));
  }
}

function* getSkillsSuggestionSaga({
  payload: { request },
}: GetSkillsSuggestionAction) {
  try {
    const response: ResponseGenerator = yield call(
      getSkillsSuggestion,
      request
    );
    yield put(getSkillsSuggestionSuccess(response.data));
  } catch (error) {
    yield put(getSkillsSuggestionsError(error));
  }
}

function* toggleSkillStateSaga({
  payload: { id, history },
}: ToggleSkillStateAction) {
  try {
    yield call(toggleSkillState, id);
    yield put(toggleSkillStateSuccess(id));
  } catch (error) {
    yield put(toggleSkillStateError(error));
  }
}

function* copySkillsSaga({ payload: { request } }: CopySkillsAction) {
  try {
    yield call(copySkills, request);
    yield put(copySkillsSuccess());
  } catch (error) {
    yield put(copySkillsError(error));
  }
}

function* SkillSaga() {
  yield takeEvery(GET_SKILLS, getSkillsSaga);
  yield takeEvery(GET_SKILLS_BY_LESSON, getSkillsByLessonSaga);
  yield takeEvery(GET_SKILLS_BY_SUBJECT, getSkillsBySubjectSaga);
  yield takeEvery(GET_SKILL, getSkillSaga);
  yield takeEvery(ADD_SKILL, addSkillSaga);
  yield takeEvery(UPDATE_SKILL, updateSkillSaga);
  yield takeEvery(DELETE_SKILL, deleteSkillSaga);
  yield takeEvery(UPLOAD_SKILL_VIDEO, uploadSkillVideoSaga);
  yield takeEvery(GET_SKILLS_SUGGESTION, getSkillsSuggestionSaga);
  yield takeEvery(TOGGLE_SKILL_STATE, toggleSkillStateSaga);
  yield takeEvery(COPY_SKILLS, copySkillsSaga);
}

export default SkillSaga;
